/* eslint-disable no-dupe-keys */
export const INSPECTION_LINKS_PAGES = {
  DECK: "Deck",
  STRUCTURE_IDENTIFICATION: "Structure Identification",
  STRUCTURE_COMPOSITION: "Structure Composition",
  SIGNS_AND_LIGHTS: "Signs & Lights",
  WALLS: "Walls",
  TUNNELS: "Tunnels",
  FEATURES: "Features",
  INSPECTION_PLANNING: "Inspection Planning",
  PRESERVATION_REHAB: "Preservation & Rehab",
  LOAD_RATING_AND_POSTING: "Load Rating & Posting",
  APPROACH: "Approach",
  SUPER_STRUCTURE: "Superstructure",
  CULVERT: "Culvert",
  ELEMENTS: "Elements",
  RATINGS: "Ratings",
  SIGNS_AND_LIGHTS: "Signs & Lights",
  SCHEDULE: "Schedule",
  JOINTS: "Joints",
  BEARINGS: "Bearings",
  WATERWAY: "Waterway",
  NOTES: "Notes",
  SUBSTRUCTURE: "Substructure",
  NSTMFATIGUE: "NSTM/Fatigue",
};

export const INSPECTION_ROUTES = {
  DECK: "/inspectionLinks/deck",
  LOAD_RATING_AND_POSTING: "/inspectionLinks/loadRatingAndPosting",
  APPROACH: "/inspectionLinks/approach",
  SUPER_STRUCTURE: "/inspectionLinks/superstructure",
  CULVERT: "/inspectionLinks/culvert",
  ELEMENTS: "/inspectionLinks/elements",
  RATINGS: "/inspectionLinks/ratings",
  SIGNS_AND_LIGHTS: "/inspectionLinks/signsAndLights",
  SCHEDULE: "/inspectionLinks/schedule",
  TUNNELS: "/inspectionLinks/tunnels",
  JOINTS: "/inspectionLinks/joints",
  BEARINGS: "/inspectionLinks/bearings",
  WALLS: "/inspectionLinks/walls",
  WATERWAY: "/inspectionLinks/waterway",
  NOTES: "/inspectionLinks/notes",
  SUBSTRUCTURE: "/inspectionLinks/substructure",
  NSTMFATIGUE: "/inspectionLinks/nstmFatigue",
};
